import React from 'react';
import { PauseCircle } from 'lucide-react';
import { useCheckoutEnabled, PAUSE_MESSAGE } from '../lib/checkoutStatus';

export const CheckoutPausedBanner = ({ onJoin, className = '' }) => {
  const enabled = useCheckoutEnabled();
  if (enabled !== false) return null;
  return (
    <div
      data-testid="checkout-paused-banner"
      className={`rounded-xl border border-amber-300 bg-amber-50 px-4 py-4 sm:px-5 text-left shadow-sm ${className}`}
    >
      <div className="flex items-start gap-3">
        <PauseCircle className="h-6 w-6 text-amber-700 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="font-semibold text-amber-900 text-base">New orders are temporarily paused</p>
          <p className="text-sm text-amber-900/80 mt-1 leading-relaxed">{PAUSE_MESSAGE}</p>
          {onJoin && (
            <button
              type="button"
              onClick={onJoin}
              data-testid="checkout-paused-banner-join-btn"
              className="mt-3 inline-flex items-center rounded-full bg-amber-600 px-4 py-2 text-sm font-semibold text-white hover:bg-amber-700 transition-colors"
            >
              Join the Waitlist
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckoutPausedBanner;
